import { Space, theme, Grid, Typography, Form, Button, Input, Tabs, message } from 'antd';
import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import api from '../../API';
import { set } from 'lodash';

const { useToken } = theme;
const { useBreakpoint } = Grid;
const { Title, Paragraph } = Typography;

function Verify() {
    const { token } = useToken();
    const screens = useBreakpoint();
    const [loading, setLoading] = useState({btnAuth: false, btnPass: false});
    const [hiddenTabs, setHiddenTabs] = useState({tab1: false, tab2: true});
    const [time, setTime] = useState(null);
    const navigate = useNavigate();
    const styles = {
      container: {
        padding: screens.md
        ? `${token.paddingXL}px`
        : `${token.sizeXXL}px ${token.padding}px`,
        width: "380px",
        borderRadius: 10,
        boxShadow: token.boxShadow,
      },
      section: {
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: token.colorBgContainer,
        display: "flex",
        height: "100vh",
      },
      title: {
        fontSize: screens.md ? token.fontSizeHeading2 : token.fontSizeHeading3,
        textAlign: "center",
        margin: "16px 0px",
        fontWeight: "bold",
      },
    };

    useEffect(() => {
      if(!sessionStorage.getItem('user_id') && !sessionStorage.getItem('count')){
        navigate('/register', { replace: true })
      }
    }, []);

    const handleOTP = async (values) => {
      try {
        setLoading({...loading, btnAuth: true});
        const { otp } = values;
        await api.verifyOTP(sessionStorage.getItem('user_id'), otp)
        setHiddenTabs({tab1: true, tab2: false});
      } catch (error) {
        message.error(error.message);
      } finally {
        setLoading({...loading, btnAuth: false});
      }
    };

    const handleChangePassword = async (values) => {  
      try {
        setLoading({...loading, btnPass: true});
        const {password} = values;
        const reponse = await api.verifyPassword(sessionStorage.getItem("user_id"),password);
        message.success(reponse.message);
        navigate('/login')
      } catch (error) {
        message.error(error.message);
      } finally {
        setLoading({...loading, btnPass: false});
      }
    }

    const handleResendEmail = async () =>{
      try {
        if(time) return;
        let count = parseInt(sessionStorage.getItem("count")) + 1;
        if(count > 5) {
          let remainingTime = 300;
          let intervalId = setInterval(() => {
            const minutes = Math.floor(remainingTime / 60);
            let seconds = remainingTime % 60;
            setTime(`${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`);
            remainingTime--;
            // Dừng đồng hồ khi hết thời gian
            if (remainingTime < 0) {
              setTime(null);
              sessionStorage.setItem("count", 0);
              clearInterval(intervalId);
            }
          },1000);
        } else {
          sessionStorage.setItem("count", count);
          const reponse = await api.resendEmailOTP(sessionStorage.getItem("user_id"));
          message.success(reponse.message);
        }
      } catch (error) {
        message.error(error.message);
      }
    }
    return (
      <section style={styles.section}>
        <Tabs 
          defaultActiveKey="1" 
          centered  
          activeKey={hiddenTabs.tab1? '2': '1'}
          style={styles.container}
          items={[
            {
              label: '1. Verify OTP',
              key: '1',
              disabled: hiddenTabs.tab1,
              children: !hiddenTabs.tab1? (
                <Space direction="vertical" > 
                  <Title level={2} style={styles.title}>Email Verification</Title>
                  <Paragraph style={{textAlign:"center"}}>Enter the 6-digit verification code that was sent to your email.</Paragraph>
                  <Form name="normal_otp" onFinish={handleOTP} layout="vertical" requiredMark="optional">
                    <Form.Item  name="otp" rules={[ { required: true, message: "Please input your OTP!"}, { pattern: /^\d{6}$/ , message: 'Please input number'}]}>
                      <Input.OTP  size="large"/>
                    </Form.Item>
                    <Form.Item style={{ marginBottom: 16 }}>
                        <Button
                        block="true"
                        type="primary"
                        size="large"
                        loading={loading.btnAuth}
                        htmlType="submit"
                        >
                        Verify Account
                        </Button>
                    </Form.Item>
                  </Form>
                  <Typography.Paragraph style={{marginBottom: 16, textAlign: "center"}}>Didn't receive code? <Typography.Link onClick={handleResendEmail} disabled={time? true: false}>Resend</Typography.Link> {time}</Typography.Paragraph>
                </Space>
              ): null,
            },
            {
              label: '2. Password',
              key: '2',
              disabled: hiddenTabs.tab2,
              children: !hiddenTabs.tab2? (
                <Space direction="vertical" style={{width: "100%"}}>
                  <Title level={2} style={styles.title}>Create Password</Title>
                  <Paragraph style={{textAlign:"center"}}>Create a new password for your account.</Paragraph>
                    <Form name="normal_password" onFinish={handleChangePassword} layout="vertical" requiredMark="optional">
                    <Form.Item  name="password" rules={[ { required: true, message: "Please input your Password!", }, {pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#])[A-Za-z\d@$!%*?&#]{8,}$/, message:'Minimum 8 characters (A->Z, a->z, 0->9, !@#...)'}]}>
                        <Input.Password placeholder="Password"/>
                    </Form.Item>
                    <Form.Item  name="confirmPassword" rules={[ 
                      { required: true, message: "Please input your Confirm Password!"},  
                      ({ getFieldValue }) => ({
                        validator(_, value) {
                          if (!value || getFieldValue('password') === value) {
                            return Promise.resolve();
                          }
                          return Promise.reject(new Error('The new password that you entered do not match!'));
                        },
                      })
                    ]}>
                        <Input.Password  placeholder="Confirm Password"/>
                    </Form.Item>
                    <Form.Item style={{ marginBottom: 16 }}>
                      <Button
                        block="true"
                        type="primary"
                        size="large"
                        loading={loading.btnPass}
                        htmlType="submit"
                        >
                        Create Account
                      </Button>
                    </Form.Item>
                  </Form>
                </Space>
              ): null,
            },
          ]}  
        />
      </section>
    )
}

export default Verify;